import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination, Region } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class RegionService extends BaseApiService<Region> {
  get cacheKey(): StorageKey {
    return StorageKey.regionServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/regions`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }
  list(params: {[params: string]: string}): Promise<Pagination<Region>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Region.unparse(obj);
  }

  protected parse(obj) {
    return Region.parse(obj);
  }

}
